"use strict";
exports.__esModule = true;
var chart_table_logic_1 = require("./chart-table.logic");
function ChartTableController($scope, $timeout) {
    var ctrl = this;
    ctrl.$onChanges = function () {
        if (!ctrl.tableData) {
            ctrl.formatedData = null;
            return;
        }
        var dataCopy = JSON.parse(JSON.stringify(ctrl.tableData));
        var inputData = dataCopy.inputData, settings = dataCopy.settings;
        if (settings) {
            ctrl.decimals = settings.decimals;
        }
        if (inputData) {
            ctrl.formatedData = chart_table_logic_1.ChartTable.generateTable(dataCopy);
        }
        else {
            ctrl.formatedData = null;
        }
        $timeout();
    };
    function exportCsv(filename, csvFormat, skipSave) {
        var csv = chart_table_logic_1.ChartTable.generateCsv(ctrl.formatedData, csvFormat);
        if (!skipSave) {
            var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
            saveAs(blob, filename);
        }
        return csv;
    }
    $scope.$on('export:csv', function (event, args, callback) {
        var csv = exportCsv(args.filename, args.csvFormat, args.skipSave || false);
        if (callback) {
            callback(csv);
        }
    });
}
angular.module('smartorg.r6.cmpts.chartTable', []).filter('textOrNumber', ['$filter', function ($filter) {
        return function (input, fractionSize) {
            if (isNaN(input) || (fractionSize == "Default")) {
                return input;
            }
            else {
                return $filter('number')(input, fractionSize);
            }
        };
    }]).component("chartTable", {
    template: require("./chart-table.component.html"),
    controller: ChartTableController,
    bindings: {
        tableData: '<',
        showAlert: '&?'
    }
});
module.exports = 'smartorg.r6.cmpts.chartTable';
//# sourceMappingURL=chart-table.component.js.map


// WEBPACK FOOTER //
// ./app/components/chart-table/chart-table.component.js